<app-contacts-add-company
  [returnRouteAbort]="'contacts/companies'"
  [returnRouteSubmit]="'contacts/companies'"
  (onAbort)="handleAbort($event)"
  (onSubmit)="handleSubmit($event)"
></app-contacts-add-company>
